(function () {
  var selectors = [
    '.oqh__inner',
    '.oqh__media',
    '.oqh-trust__caption',
    '.oqh-trust__item',
    '.oq-card',
    '.oq-history__media',
    '.oq-history__copy',
    '.oq-why__intro',
    '.oq-why__card',
    '.oq-about__intro',
    '.oq-about__media',
    '.oq-about__fact',
    '.oq-about__chronicle-head',
    '.oq-about__timeline li',
    '.oq-services__intro',
    '.oq-service-row',
    '.oq-services__process',
    '.oq-services__closing',
    '.oq-contact__intro',
    '.oq-contact__routes > *',
    '.oq-shop__intro',
    '.oq-shop-line',
    '.m-featured-collection--home .m-section__header',
    '.m-featured-collection--home .m-product-card',
    '.m-collection-page-header__inner',
    '.m-collection-products .m-product-card',
    '.m-collection-list-template .m-collection-card',
    '.m-main-product--media',
    '.m-product-info--wrapper',
    '.m-product-details-tabs',
    '.m-contact-form__main',
    '.m-contact-form__info',
    '.m-search--form',
    '.m-search-result .m-product-card',
    '.oq-quote',
    '.oq-faq__item',
    '.oq-cta-final'
  ];

  function initMotion() {
    if (window.matchMedia && (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      window.matchMedia('(max-width: 767px)').matches
    )) return;

    var items = Array.prototype.slice.call(document.querySelectorAll(selectors.join(',')));
    if (!items.length) return;

    document.documentElement.classList.add('oq-motion-ready');

    items.forEach(function (item, index) {
      item.classList.add('oq-motion-item');
      item.style.setProperty('--oq-motion-delay', Math.min((index % 8) * 42, 180) + 'ms');
    });

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.14,
      rootMargin: '0px 0px -10% 0px'
    });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMotion, { once: true });
  } else {
    initMotion();
  }
})();
